import { Component, HostListener, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonDataService } from 'src/app/common/services/common-data.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  //styles:['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent{

  @HostListener('document:keydown', ['$event']) onKeyPress(event: KeyboardEvent) {
    if (event.key === "Escape") {
      this.dialogRef.close();
      this.commonDataService.isConfirmationPopUpOpen.next(false);
    }
  }

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    public commonDataService: CommonDataService, public router: Router ,
    @Inject(MAT_DIALOG_DATA) public message: string) { }
  path: any;
  val: boolean = false;
  temppath: any;

  onNoClick(): void {
    this.val = false;
    this.dialogRef.close(this.val);   
    this.commonDataService.isConfirmationPopUpOpen.next(false);
  }
  onYesClick() {
    this.val = true;
    this.dialogRef.close(this.val);    
    this.commonDataService.isConfirmationPopUpOpen.next(false);
    localStorage.setItem("SetPrintQueueSession", JSON.stringify({}));
    localStorage.removeItem("isConfirmPopup");
  }
  onGenerateReportAlertClick(): void {
    this.dialogRef.close();
    this.commonDataService.isConfirmationPopUpOpen.next(false);
    this.commonDataService.CrossRefReportNotGenerated.next(true);
  }
  display: boolean = false;

  displayTitle: string = "";
  EnableOkButton: boolean = false;
  ngOnInit() {
    this.commonDataService.CrossRefReportNotGenerated.subscribe(data => {
      this.commonDataService.aaaUserMessage.subscribe(aaa => {
        if (aaa) {
          this.displayTitle = "Alert !";
          this.EnableOkButton = true;
          return;
        }
        else {
          if (localStorage.getItem("isConfirmPopup") == 'true') {
            this.displayTitle = "";
            return;
          }
          this.display = data
          if (this.display) {
            this.displayTitle = "Delete Confirmation !";
          }
          else {
            this.displayTitle = "Alert !";
            this.EnableOkButton = true;
          }
        }
      })

    })
  }
    

}
